var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEwiChatbotToolEmptyBig = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.8027 58.3163C85.8417 58.166 85.8792 58.0147 85.9163 57.8633C85.8795 58.0147 85.8411 58.1655 85.8027 58.3163Z",
    fill: "#BFE5FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0005 5.7832C28.7961 5.7832 18.8149 14.9227 18.7874 14.9382C18.162 17.8249 17.0742 22.014 17.0742 25.0879C17.0742 48.3437 36.6858 67.1917 59.9415 67.1917C69.8521 67.1917 78.9579 62.5773 86.1509 56.8481C86.1803 56.6686 87.1087 52.9714 87.1087 47.8916C87.1088 24.6358 68.2562 5.7832 45.0005 5.7832Z",
    fill: "#F0F2FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9375 66.0033C36.6818 66.0033 17.8291 47.1507 17.8291 23.895C17.8291 20.8211 18.1617 17.8252 18.7869 14.9385C18.786 14.9392 18.785 14.9401 18.7841 14.9408C9.10002 22.6558 2.8916 34.5479 2.8916 47.8919C2.8916 63.8733 11.7946 77.7752 24.9115 84.9086L68.5421 82.8073C76.9681 77.113 83.222 68.4478 85.8027 58.315C85.8411 58.1642 85.8797 58.0134 85.9163 57.862C85.9338 57.7899 86.0926 57.1152 86.1504 56.8482C78.9575 62.5777 69.8481 66.0033 59.9375 66.0033Z",
    fill: "#D8DEFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0654 33.6797V88.4261C51.9505 88.2797 57.5351 88.4841 62.5814 86.1611C64.6651 85.202 66.6571 84.0776 68.5406 82.8045L70.7246 33.6797H46.0654Z",
    fill: "#93A0FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5811 86.1608H54.4105C50.1572 86.1608 46.7092 82.7128 46.7092 78.4595V33.6797H22.6338L24.9113 84.9073C30.8817 88.1543 37.7253 89.9991 44.9996 89.9991C51.2763 89.9991 57.2308 88.6237 62.5811 86.1608Z",
    fill: "#6C7DE5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9499 16.1279L24.8486 35.2292L15.4363 25.8169C13.0486 23.4292 13.0486 19.5439 15.4363 17.1561L25.8768 6.7156C28.2646 4.32787 32.1499 4.32787 34.5376 6.7156L43.9499 16.1279ZM24.8486 28.1252L36.8459 16.1279L30.9855 10.2675C30.5563 9.8383 29.858 9.8383 29.4287 10.2675L18.9882 20.708C18.559 21.1373 18.559 21.8356 18.9882 22.2648L24.8486 28.1252Z",
    fill: "#6C7DE5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5342 26.0605L46.589 0.0057459L54.9436 8.36033L28.8888 34.4151L20.5342 26.0605Z",
    fill: "#93A0FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71875 37.873L21.6548 24.937L30.0094 33.2916L17.0733 46.2276L8.71875 37.873Z",
    fill: "#5767DB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6802 86.1933C45.0618 86.1933 43.75 84.8814 43.75 83.2631V47.3111C43.75 45.6926 45.062 44.3809 46.6802 44.3809C48.2986 44.3809 49.6104 45.6928 49.6104 47.3111V83.2631C49.6104 84.8814 48.2986 86.1933 46.6802 86.1933Z",
    fill: "#5767DB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0159 86.1935C33.4664 86.1935 32.1722 84.9782 32.0919 83.4132L30.25 47.4611C30.1672 45.8448 31.4103 44.4675 33.0264 44.3847C34.6461 44.3026 36.02 45.5452 36.1028 47.1611L37.9447 83.1132C38.0275 84.7295 36.7844 86.1068 35.1683 86.1896C35.1172 86.1923 35.0663 86.1935 35.0159 86.1935Z",
    fill: "#5767DB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6291 86.1937C58.5784 86.1937 58.5279 86.1925 58.4768 86.1898C56.8605 86.1071 55.6176 84.7296 55.7002 83.1135L57.5421 47.1614C57.6249 45.5451 59.0009 44.3021 60.6185 44.3847C62.2348 44.4675 63.4777 45.845 63.3951 47.4611L61.5532 83.4132C61.4729 84.9784 60.1785 86.1937 58.6291 86.1937Z",
    fill: "#5767DB"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEwiChatbotToolEmptyBig);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EWI_chatbot_tool_empty_big.ac67656827a9c765dc8df365d0f7cd58.svg";